import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import isMultiDomain from 'utils/isMultiDomain';
import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import DistributedContentIcon from 'components/DistributedContentIcon';
import { useFetchContent } from 'actions/content';
import renderItemThumbnail from './renderItemThumbnail';
function AssetPickerModal(_ref) {
  var isDisabled = _ref.isDisabled,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    defaultSelectedItems = _ref.defaultSelectedItems,
    defaultIndeterminateItems = _ref.defaultIndeterminateItems,
    _ref$disabledItems = _ref.disabledItems,
    disabledItems = _ref$disabledItems === void 0 ? [] : _ref$disabledItems,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'asset' : _ref$type,
    privilege = _ref.privilege,
    audience = _ref.audience,
    teamIds = _ref.teamIds,
    owner = _ref.owner,
    getFullData = _ref.getFullData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useFetchContent = useFetchContent({
      audience: audience,
      search: searchValue,
      teamIds: teamIds,
      type: type,
      privilege: privilege,
      owner: owner,
      getFullData: getFullData
    }),
    items = _useFetchContent.items,
    hasNextPage = _useFetchContent.hasNextPage,
    fetchNextPage = _useFetchContent.fetchNextPage,
    isError = _useFetchContent.isError,
    isLoading = _useFetchContent.isLoading,
    isFetchingNextPage = _useFetchContent.isFetchingNextPage;
  var labels = {
    getSelectionStatus: function getSelectionStatus(count) {
      return t('asset_selection_status', {
        count: count
      });
    }
  };
  var renderSubtitle = function renderSubtitle(item) {
    return t(getContentItemTypeTranslationKey(getContentItemType(item)));
  };
  var distributedIcon = function distributedIcon(item) {
    return isMultiDomain(item) && /*#__PURE__*/React.createElement(DistributedContentIcon, {
      type: item.type
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    id: "reports-asset-selector",
    "aria-label": t('actions_select_assets'),
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(ItemPicker, {
    isDisabled: isDisabled,
    title: t('actions_select_assets'),
    labels: labels,
    items: items,
    defaultSelectedItems: defaultSelectedItems,
    defaultIndeterminateItems: defaultIndeterminateItems,
    disabledItems: disabledItems,
    isLoading: isLoading,
    isError: isError,
    hasNextPage: hasNextPage,
    onFetchNextPage: fetchNextPage,
    isFetchingNextPage: isFetchingNextPage,
    onSubmit: onSubmit,
    onClose: onClose,
    onSearchValueChange: setSearchValue,
    renderItemIcon: renderItemThumbnail,
    renderItemSubtitle: renderSubtitle,
    renderInlineIcon: distributedIcon
  }));
}
export default AssetPickerModal;